// Client for the Daksfirst Strapi CMS at https://cms.daksfirst.com
// Same endpoints used by the live daksfirst.com SPA.
// Returns null on failure so the caller can fall back to a hardcoded list.

const BASE = "https://cms.daksfirst.com";

function normaliseImage(url) {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  if (url.startsWith("/")) return `${BASE}${url}`;
  return `${BASE}/${url}`;
}

export async function fetchTeam() {
  try {
    const res = await fetch(`${BASE}/api/peoples?sort=order:asc&pagination[pageSize]=100`);
    if (!res.ok) throw new Error(`CMS responded ${res.status}`);
    const json = await res.json();
    const rows = json?.data || [];
    return rows.map((item) => {
      const a = item.attributes || item;
      return {
        id: item.id,
        name: a.Name || "",
        role: a.Designation || "",
        bio: a.Description || "",
        photo: normaliseImage(a.ImgLink || ""),
        link: a.Link || ""
      };
    });
  } catch (err) {
    if (typeof console !== "undefined") {
      console.warn("CMS team fetch failed, using fallback:", err.message);
    }
    return null;
  }
}

export async function fetchTransactions() {
  try {
    const res = await fetch(`${BASE}/api/transactions?pagination[pageSize]=100`);
    if (!res.ok) throw new Error(`CMS responded ${res.status}`);
    const json = await res.json();
    const rows = json?.data || [];
    return rows.map((item) => {
      const a = item.attributes || item;
      return {
        id: item.id,
        type:         a.Type || a.type || "",
        jurisdiction: a.Jurisdiction || a.jurisdiction || "",
        sector:       a.Sector || a.sector || "",
        amount:       a.Amount || a.amount || "",
        dealClosed:   a.Deal_Closed || a.DealClosed || a.deal_closed || a.Year || a.year || "",
        status:       a.Status || a.status || "Closed",
        image:        normaliseImage(a.img_link || a.imgLink || a.ImgLink || a.image || ""),
        link:         a.link_url || a.linkUrl || a.LinkUrl || a.link || "",
        description:  a.Description || a.description || "",
        // legacy aliases used elsewhere
        structure:    a.Structure || a.structure || "",
        year:         a.Deal_Closed || a.DealClosed || a.deal_closed || a.Year || a.year || ""
      };
    });
  } catch (err) {
    if (typeof console !== "undefined") {
      console.warn("CMS transactions fetch failed, using fallback:", err.message);
    }
    return null;
  }
}

// Status pill class — maps free-text status from CMS to a visual style.
export function statusClass(status) {
  const s = (status || "").toString().toLowerCase();
  if (s.includes("exit") || s.includes("realis") || s.includes("realiz")) return "exited";
  if (s.includes("close")) return "closed";
  if (s.includes("ongoing") || s.includes("active") || s.includes("live") || s.includes("current")) return "live";
  return "live";
}

// Returns a favicon URL for a given site URL (Google S2 favicon service, fallback when no logo file).
export function faviconUrl(href, size = 64) {
  try {
    const u = new URL(href);
    return `https://www.google.com/s2/favicons?domain=${u.hostname}&sz=${size}`;
  } catch {
    return null;
  }
}
